<template>
  <div
    class="modal"
    @click.self="$emit('close')"
  >
    <div class="modal-content">
      <dn-button
        class="button-close"
        @click.prevent="$emit('close')"
      >
        <span />
        <span />
        <span />
      </dn-button>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineEmits(['close']);
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--background-modal);
  width: 100%;
  height: 100%;
}

.modal-content {
  position: relative;
  width: 100%;
  max-width: var(--content-width);
  background-color: var(--color-neutral-0);
  border-radius: var(--box-radius);
  font-size: var(--copy-size);
  color: var(--color-neutral-800);
  overflow-y: auto;
  padding: var(--ui-gap);

  iframe {
    border-radius: var(--box-radius);
    border: none;
  }

  .button {
    &-close {
      --dn-button_background_hover: none;
      --dn-button_background_active: none;

      position: absolute;
      right: var(--row-gap);
      top: var(--row-gap);
      z-index: 2;
      display: flex;
      border: none;
      width: 28px;
      max-width: 28px;
      height: 28px;
      padding: 0;

      span {
        position: absolute;
        left: 0;
        background-color: var(--color-neutral-700);
        width: 100%;
        height: 1px;
        transition: all 0.2s linear;
        transform: rotate(0deg) scaleY(1.5);
        transform-origin: top;

        &:nth-child(1) {
          left: 50%;
          top: 18px;
          width: 0;
        }

        &:nth-child(2),
        &:nth-child(3) {
          top: 14px;
        }

        &:nth-child(2) {
          transform: rotate(45deg) scaleY(1.5);
        }

        &:nth-child(3) {
          transform: rotate(-45deg) scaleY(1.5);
        }
      }
    }
  }
}
</style>
